import { Dialog, DialogTitle, DialogContent, DialogActions, TablePagination } from "@mui/material";
import { StyledDataGrid } from "../components/styled_data_grid";
import { GridColDef } from "@mui/x-data-grid-pro";
import { logTipoAcaoToString, logTipoTabelaToString } from "../utils/log_tabela_tipo";
import { LogAlteracao } from "../domain/models/log_alteracao";
import { ChangeHistoryState } from "../hooks/use_change_history";
import { useMemo } from "react";

import dayjs from "dayjs";

/**
 * columns
 */

const GenerateColumnDefinition = (showDate?: boolean): GridColDef[] => {
  if (showDate === false) {
    return [
      {
        field: "tipoTabela",
        filterable: false,
        headerName: "Item modificado",
        flex: 1,
        minWidth: 120,
        sortable: false,
        renderCell: ({ value }) => {
          return <div>{logTipoTabelaToString(value)}</div>;
        },
      },
      {
        field: "idTabela",
        filterable: false,
        headerName: "Id do Item",
        width: 120,
        sortable: false,
      },
      {
        field: "loginUsuario",
        filterable: false,
        headerName: "Usuário",
        flex: 1,
        minWidth: 120,
        sortable: false,
      },
      {
        field: "tipoAcao",
        filterable: false,
        headerName: "Tipo de ação",
        width: 120,
        sortable: false,
        renderCell: ({ value }) => {
          return <div>{logTipoAcaoToString(value)}</div>;
        },
      },
    ];
  }
  return [
    {
      field: "tipoTabela",
      filterable: false,
      headerName: "Item modificado",
      flex: 1,
      minWidth: 120,
      sortable: false,
      renderCell: ({ value }) => {
        return <div>{logTipoTabelaToString(value)}</div>;
      },
    },
    {
      field: "idTabela",
      filterable: false,
      headerName: "Id do Item",
      width: 90,
      sortable: false,
    },
    {
      field: "loginUsuario",
      filterable: false,
      headerName: "Usuário",
      flex: 1,
      minWidth: 120,
      sortable: false,
    },
    {
      field: "sistema",
      filterable: false,
      headerName: "Sistema",
      width: 100,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div>
            {value ?? "Web"}
          </div>
        );
      },
    },
    {
      field: "dataHora",
      filterable: false,
      headerName: "Data e hora",
      width: 120,
      sortable: false,
      renderCell: ({ value }) => {
        return <div>{dayjs.utc(value).local().format('DD/MM/YYYY HH:mm')}</div>;
      },
    },
    {
      field: "tipoAcao",
      filterable: false,
      headerName: "Tipo de ação",
      width: 120,
      sortable: false,
      renderCell: ({ value }) => {
        return <div>{logTipoAcaoToString(value)}</div>;
      },
    },
  ];
}

/**
 * ChangeHistoryModal
 */

type Props = {
  changeHistoryHandler: ChangeHistoryState,
};

export const ChangeHistoryModal = ({
  changeHistoryHandler,
}: Props) => {

  const columnDefinition = useMemo(() => {
    return GenerateColumnDefinition(changeHistoryHandler.showDateColumn);
  }, [
    changeHistoryHandler.showDateColumn,
  ]);

  return (
    <Dialog
      open={changeHistoryHandler.openChangeHistoryModal}
      onClose={changeHistoryHandler.handleCloseChangeHistory}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "80rem",
          },
        },
      }}>
      <DialogTitle>
        Historico de alterações
      </DialogTitle>

      <DialogContent>
        <div className="w-full">
          <StyledDataGrid
            tableName="change_history_modal"
            disableColumnMenu={false}
            getRowId={(r: LogAlteracao) => r.idLogAlteracao}
            height="38rem"
            textSize="pequeno"
            columns={columnDefinition}
            loading={changeHistoryHandler.loading}
            rows={changeHistoryHandler.alteracoes}
            rowCount={changeHistoryHandler.alteracoes.length}
            pageSizeOptions={[100]}
            paginationMode="server"
            paginationModel={{
              page: changeHistoryHandler.pagination.page - 1,
              pageSize: changeHistoryHandler.pagination.rowsPerPage,
            }} />

          <TablePagination
            component="div"
            count={changeHistoryHandler.pagination.totalItems}
            page={changeHistoryHandler.pagination.page - 1}
            rowsPerPageOptions={[100]}
            onPageChange={(_, p) => changeHistoryHandler.handleChangeHistoryPageChange(p)}
            rowsPerPage={changeHistoryHandler.pagination.rowsPerPage}
            onRowsPerPageChange={(e) => { }} />

        </div>
      </DialogContent>

      <DialogActions>
        <div className="w-full h-full items-center justify-end flex p-4 gap-4">
          <div className="flex flex-row gap-2">
            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
              <h1
                className="text-sm text-black dark:text-white"
                onClick={changeHistoryHandler.handleCloseChangeHistory}>
                Fechar
              </h1>
            </div>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}